import {
  DelayStep,
  ValueOrigin,
} from 'pages/AutomationEngine/types/delay-types';

export const delayRemoveVariable = (
  step: DelayStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (
    step.details.valueOrigin === ValueOrigin.automation_variable &&
    step.details.variable.value === variableName
  ) {
    if (!nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    return {
      nextStep: {
        ...step,
        details: {
          ...step.details,
          variable: { ...step.details.variable, deleted: true },
        },

        hasError: true,
      },
      nextErrorIds,
    };
  }
  return { nextStep: step, nextErrorIds: [] };
};
